import { ApolloQueryResult } from '@apollo/client';
import { Accordion, EventsTimeline, Separator, Text } from '@shared/components';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { ShipmentQuery } from '@shared/generated/graphql';
import { ScheduleStop } from 'clerk_common/types';
import { Stop } from './Stops/Stop';

type VoomaScheduleProps = {
  shipmentId: string;
  stops: ScheduleStop[];
  refetchShipment: () => Promise<ApolloQueryResult<ShipmentQuery>>;
};
export function VoomaSchedule({
  shipmentId,
  stops,
  refetchShipment,
}: VoomaScheduleProps) {
  const { hasSchedule } = useMeContext();

  if (!hasSchedule) return null;

  const trigger = (
    <Text type="body-sm" isHeavy>
      Schedule
    </Text>
  );
  const children = (
    <ScheduleContents
      shipmentId={shipmentId}
      stops={stops}
      refetchShipment={refetchShipment}
    />
  );
  return (
    <div className="flex flex-col gap-2">
      <Separator />
      <Accordion
        sections={[{ trigger, children, startOpen: true }]}
        triggerClassName="h-[36px]"
      />
    </div>
  );
}

type ScheduleContentsProps = {
  shipmentId: string;
  stops: ScheduleStop[];
  refetchShipment: () => Promise<ApolloQueryResult<ShipmentQuery>>;
};
export function ScheduleContents({
  shipmentId,
  stops,
  refetchShipment,
}: ScheduleContentsProps) {
  return (
    <div className="flex flex-col gap-2">
      <EventsTimeline>
        {stops.map((stop, i) => (
          <Stop
            key={i}
            stop={stop}
            index={i}
            shipmentId={shipmentId}
            refetchShipment={refetchShipment}
          />
        ))}
      </EventsTimeline>
    </div>
  );
}
